import { Circle } from 'ol/style';
import RRegularBase from './RRegularBase';
/**
 * A circle
 *
 * Requires an `RStyle` context
 *
 * Provides an `RStyle` context - for `Fill` or `Stroke`
 */
class RCircle extends RRegularBase {
    create(props) {
        this.classProps = RCircle.classProps;
        return new Circle(Object.assign(Object.assign({}, props), { stroke: this.stroke, fill: this.fill }));
    }
}
RCircle.classProps = RRegularBase.classProps.concat(['radius']);
export default RCircle;
//# sourceMappingURL=RCircle.js.map